import { getClientQueryParam } from '@ori/presentation-utils';
import { useEffect, useRef } from 'react';

/** Runs action with a delay when `openChat` query param is `true` */
export const useOpenChatQueryParamOnMount = (action: () => void, delay: number) => {
  const actionExecuted = useRef(false);

  useEffect(() => {
    const openChatAsString = getClientQueryParam('openChat');
    const openChat = openChatAsString === 'true';

    if (!actionExecuted.current && openChat) {
      const timeoutId = setTimeout(() => {
        action();
        actionExecuted.current = true;
      }, delay);

      return () => clearTimeout(timeoutId);
    }

    return () => {};
  }, [action, delay]);
};
